module.exports = __webpack_public_path__ + "img/1 (65).4f48654e.png";